export default __webpack_public_path__ + "static/media/phone.84f8932a.png";